export default "__VITE_ASSET__9c06bc5d__"